import React, { ReactElement } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { COMPLETED_COMMENT, COMPLETED_TITLE } from '@constants/text';

function Completed(): ReactElement {
  return (
    <Layout>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{COMPLETED_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={3} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{COMPLETED_COMMENT}</TypographyText>
        </Col>
      </Row>
    </Layout>
  );
}

export default Completed;
